import { combineReducers } from "redux";
import authReducer from "./getAuthReducer";
import propertyListReducer from "./getPropertySelectionListReducer";
import modalReducer from "./getModalReducer/modalReducer";
import curPropertyDetailsReducer from "./getCurrentPropertyDetailsReducer";
import vwPropertyDetailsReducer from "./getViewPropertyDetailsReducer";
import propertyDocsReducer from "./getPropertyDocumentsReducer";
import docReducer from "./getDocumentReducer";
import repsReducer from "./getReportsReducer";
import repReducer from "./getReportReducer";
import SnapshotsListReducer from "./getSnapshotsListReducer";
import SnapShotReducer from "./getSnapshotInfoReducer";
import RollNumberReducer from "./getRollNumberReducer";
import rfrReducer from "./getRfrReducer"
import toastifyReducer from "./getToastNotificationReducer";
import { AppAction } from "../types";
import { LOGIN_AUTH } from "../actionTypes/actionsTypes";
import chatReducer from "./getLiveChatReducer";
import pierLinkTextReducer from "./getPierMessageReducer";
import NBHDReducer from "./getNBHDReducer";
import ampStatusReducer from "./getAmpStatusReducer";
import tenantProfileReducer from './getTenantProfileReducer';
import mailingAddressRoot from "./getPropMailingAddressReducer";
import enotifReducers from "./getEnotifReducer";

// export default combineReducers({ colourReducer, authReducer, formReducer, dashReducer });
const combinedReducer = combineReducers({ 
    authReducer,
    propertyListReducer, 
    modalReducer, 
    curPropertyDetailsReducer, 
    vwPropertyDetailsReducer, 
    propertyDocsReducer, 
    docReducer, 
    rfrReducer, 
    toastifyReducer, 
    SnapshotsListReducer, 
    chatReducer, 
    repsReducer, 
    repReducer, 
    RollNumberReducer, 
    SnapShotReducer, 
    pierLinkTextReducer, 
    NBHDReducer, 
    ampStatusReducer, 
    tenantProfileReducer,
    mailingAddressRoot,
    enotifReducers
});

export type RootState = ReturnType<typeof combinedReducer>;

export const rootReducer = (state: RootState, action: AppAction) => {
    if (action.type === LOGIN_AUTH.SUCCESS) {
        state = {} as RootState;
    }
    return combinedReducer(state, action);
}